"use client";

const _excluded = ["size"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
import React from "react";
import BaseIcon from "../../utils/BaseIcon";
const PhoneSystemIcon = props => {
  const {
      size = 24
    } = props,
    otherProps = _objectWithoutProperties(props, _excluded);
  const iconFill = "currentColor";
  return /*#__PURE__*/React.createElement(BaseIcon, _extends({
    size: size
  }, otherProps, {
    "data-mesh-component": "PHONE-SYSTEM-ICON"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: iconFill,
    fillRule: "nonzero",
    d: "m14.732 22.972.012.006c2.44 1.555 5.664 1.2 7.73-.865l.768-.767a2.58 2.58 0 0 0 0-3.646l-3.232-3.23a2.58 2.58 0 0 0-3.646 0 1.077 1.077 0 0 1-1.524 0L9.67 9.298a1.08 1.08 0 0 1 0-1.525 2.576 2.576 0 0 0 0-3.645L6.439.894A2.58 2.58 0 0 0 2.792.893l-.767.767a6.235 6.235 0 0 0-.852 7.755l.017.026a50.241 50.241 0 0 0 13.5 13.504l.042.027M2.436 8.605l-.006-.008a4.731 4.731 0 0 1 .656-5.876l.767-.767a1.08 1.08 0 0 1 1.525 0l3.23 3.234a1.077 1.077 0 0 1 0 1.524 2.58 2.58 0 0 0 0 3.646l5.171 5.172a2.576 2.576 0 0 0 3.646 0 1.08 1.08 0 0 1 1.525 0l3.231 3.23c.42.421.42 1.104 0 1.525l-.767.767a4.733 4.733 0 0 1-5.889.646l-.01-.006A48.735 48.735 0 0 1 2.435 8.605"
  })));
};
PhoneSystemIcon.displayName = "PhoneSystemIcon";
PhoneSystemIcon.iconName = "Phone";
export default PhoneSystemIcon;